import React, { memo,useRef, useEffect, useCallback, useState} from 'react';
import ZObjectTooltip from "components/zobject/ZObjectTooltip.js";
import ZObjectContextMenus from "components/zobject/ZObjectContextMenus.js"
import {
    setSelectedZObject,
    setViewableSubPatches} from 'actions/index.js';
import PadEffects from 'components/pulled/PadEffects.js';
import {useEditorKeys} from "components/v3/editor/useEditorKeys.js";
import {useWindows} from "components/windows/useWindows.js";
import SubPatchSize from './SubPatchSize.js';
import {useZObjectDrop} from "components/pulled/useZObjectDrop.js";
import {useDoubleClick} from "components/hooks/useDoubleClick.js";
import GlobalEdges from "components/pulled/GlobalEdges.js";
import PulledBackground from "components/spatial/PulledBackground.js";
import {useContainerCoords} from "components/hooks/useContainerCoords.js";
import {useSelection} from "components/windows/useSelection.js";
import {setModuleSize, setSelectedPulledElements} from 'actions/index.js';
import ZObjectComponent from "components/zobject/ZObjectComponent.js";
import ZMessageComponent from "components/zobject/ZMessageComponent.js";
import {connect} from 'react-redux';

const SubPatchContent = memo(({
    len,
    subpatch,
    setSize,
    setSelectedPulledElements,
    isInstrumentView,
    customMode,
    scrollRef,
    editLayout,
    presentationMode,
    isInsideWindow,
    setSelectedZObject,
    setViewableSubPatches
}) => { 
    let zobjects= subpatch.zObjects;
    let zmessages= subpatch.zMessages;

    const edgesRef = useRef();
    const elements = useRef({});
    const {sizeRef, ordering, setOrdering} = useWindows();
    const ref = scrollRef;
    let {getSelection} = useSelection({elements});
    let [selection, setSelection] = useState(undefined);
    let {getXY} = useContainerCoords({containerRef: ref, scale: 1});

    const onDoubleClick = useCallback((e) => {
        if (isInsideWindow) {
            return;
            e.stopPropagation();
            let spatches = subpatch.sequencerEngine.state.zobject.viewableSubPatches;
            setViewableSubPatches(
                [... spatches, subpatch]);
        } else {
            e.stopPropagation();
            let {x,y} = getXY(e);
            subpatch.createZObject(x,y);
        }
    }, []);
    
    const onClick = useDoubleClick(onDoubleClick, 250, (e) => {
        if (!isInsideWindow) {
            e.stopPropagation();
        }
    });

    let {onMouseMove} = useEditorKeys(
        {
            scrollRef: ref,
            sequencerEngine: subpatch.sequencerEngine,
            context: subpatch
        });

    const onMouseDown = useCallback((e) => {
        if (customMode === "custom") {
            setSelectedZObject(subpatch.zObject);
        }
        if (!ref || !ref.current) {
            return;
        }

       let {x,y} = getXY(e);
        setSelection({x1: x, y1: y, x2: x, y2: y});
    }, [setSelection, customMode]);

    const onContentMouseMove = useCallback((e) => {
        onMouseMove(e);
        if (selection) {
            let {x,y} = getXY(e);
            setSelection({...selection, x2: x, y2: y});
        }
    }, [selection, setSelection]);

    const onMouseUp = useCallback((e) => {
        if (selection && selection.x2 - selection.x1 > 1) {
            let selectedElements = getSelection(selection);
            let x = {};
            for (let {id} of selectedElements) {
                x[id] = true;
            }
            setSelectedPulledElements(x);
        }
        if (selection) {
            setSelection(undefined);
        }
    }, [selection, setSelection]);

    const {onDrop} = useZObjectDrop({ref, subSequence: subpatch, setSelection});

    // if we are editing layout or the instrument view (i.e. the instrumetn being shown
    // in parent sub-class/main-patcher), then we want to tell this to the zobject being rendered
    // so that it can use "presentation-mode" positions

    let className = "content-inner";
    if (presentationMode || editLayout || isInstrumentView) {
        className += " presentation-mode";
    }

    return (
        <div
          onDrop={onDrop}
          //onMouseDown={onMouseDown}
          //onMouseMove={onContentMouseMove}
          //onMouseUp={onMouseUp}
          onClick={onClick}
          ref={scrollRef} className={className}>
          {customMode !== "custom" && <ZObjectTooltip subSequence={subpatch}/>}
          {customMode !== "custom" && <ZObjectContextMenus subSequence={subpatch}/>}
          {customMode !== "custom" && <PulledBackground
                                        isSubPatch={true}
                                        scale={1}
                                        sequencerEngine={subpatch.sequencerEngine}
                                        getXY={getXY}
                                        setSelectedZObject={setSelectedZObject}
                                        onMouseMove={onMouseMove}
                                        getSelection={getSelection}
                                        editorRef={scrollRef}
                                 
                                      />}
          {editLayout && customMode === true && <SubPatchSize scrollRef={ref} subpatch={subpatch}/>}

          {zobjects.map(
              obj => <ZObjectComponent
                       key={obj.id}
                       scale={1}
                       elements={elements}
                       sequencerEngine={subpatch.sequencerEngine}
                       ordering={ordering}
                       isInstrumentView={isInstrumentView || editLayout}
                       setOrdering={setOrdering}
                       customMode={customMode==="custom" ? customMode : customMode && editLayout}
                       setSize={setSize}
                       sizeRef={sizeRef}
                       containerRef={ref}
                       zobject={obj}/>)}
          
          {zmessages
           .map(
              obj => <ZMessageComponent
                       key={obj.id}
                       scale={1}
                       sequencerEngine={subpatch.sequencerEngine}
                       isInstrumentView={isInstrumentView || editLayout}
                       setOrdering={setOrdering}
                       ordering={ordering}
                       customMode={customMode === "custom" ? "custom" :customMode && editLayout}
                       setOrdering={setOrdering}
                       setSize={setSize}
                       sizeRef={sizeRef}
                       elements={elements}
                       containerRef={ref}
                       zmessage={obj}/>)}

          { (!customMode || (customMode === true && !editLayout)) && subpatch.zObjects.filter(x => x.name === 'pad')
           .filter(x => x.effect.pad)
           .map(x => x.effect.pad)
           .filter(pad => pad.effectRack)
           .map(
              pad => 
                  <PadEffects
                    scale={1}
                    ordering={ordering}
                    setOrdering={setOrdering}
                    setSize={setSize}
                    sizeRef={sizeRef}
                    elements={elements}
                    containerRef={ref}
                    pad={pad}/>)}

          {ref && ref.current && (!customMode || (customMode && !editLayout)) &&
           <GlobalEdges
             edgesRef={edgesRef}
             scrollable={true}
             width={ref.current && ref.current.scrollWidth}
             height={ref.current && ref.current.scrollHeight}
             selection={selection}
             containerRef={ref}
             scale={1}
             subSequence={subpatch}/>}
        </div>
    );
});

const mapStateToProps = (state, props) => {
  return {
      len: props.subpatch.zObjects.length,
      zobjects: state.zobject.zobjects[props.subpatch.id],
      zmessages: state.zobject.zmessages[props.subpatch.id],
      presentationMode: state.spatial.presentationMode,
  };
};

const mapDispatchToProps = (dispatch, props) => {
  return {
        setSize: x => dispatch(
            setModuleSize(props.subpatch.id, x)),
        setSelectedPulledElements: x => dispatch(
            setSelectedPulledElements(x)),
      setViewableSubPatches: x => dispatch(setViewableSubPatches(x)),
      setSelectedZObject: x => dispatch(setSelectedZObject(x))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SubPatchContent);
